/* RemixHelper.js */

import TextPhotoDefaults from "../enums/TextPhotoDefaults";
import CanvasHelper from "./CanvasHelper";
import LayerIdGenerator from "./LayerIdGenerator";

const EXPRESS_URL = process.env.REACT_APP_EXPRESS_URL;
const PUBLIC_VIDEOS_URL = process.env.REACT_APP_PUBLIC_VIDEOS;
const PUBLIC_VIDEOS_URL_POPFANS = process.env.REACT_APP_PUBLIC_VIDEOS_POPFANS;
const REMIX_APP_WEB = process.env.REACT_APP_REMIX_APP_WEB;
const POPFANS_APP_WEB = process.env.REACT_APP_POPFANS_APP_WEB;

const randomIntFromInterval = (min, max) => { return Math.floor(Math.random() * (max - min + 1) + min) }

const RemixHelper = {
  getDefaultRemixArguments: () => {
    return {
      rde: ' ||) ',
      blksnow: 0,
      edate: '00',
      mvon: 0,
      rfsownernm: 30,
      sdate: '00',
      rpdt: '3.00',
      rperm: 3,
      rssm: 1,
      easv: 3,
      rautoapp: 0,
      rdmdown: 1,
      dppref: 1,
      blksae: 0,
      blksbs : 0,
      rmcsa: 1,
      rpsende: 3,
      ebo: 'PictureDescription',
      rops: 11,
      tsocial: 0,
      rinsta: 1,
      rsmir: 0,
      rpsmc: 3
    };
  },

  generateStarTag: (text) => {
    let startag = text;
    startag = startag.toLowerCase();
    startag = startag.trim();
    startag = startag.replace(/[^a-z0-9 _]/g, ''); // Remove all special chars except space and underline
    startag = startag.replace(/\s+/, ' '); // remove double spaces
    startag = startag.replaceAll(' ', '_');
    if (startag.length > 24) {
      startag = startag.substring(0, 23);
    }
    return startag;
  },

  randomizeStyle: async (styles, catsImages, previousSelected = null) => {
    let selectedStyle;
    if (styles && styles.length > 0) {
      let selected = false;
      let whileCount = 0;
      while (!selected && whileCount < 5) {
        const maxRandom = (styles.length > 16) ? 15 : styles.length - 1;
        const random = randomIntFromInterval(0, maxRandom);
        selectedStyle = (styles[random]);
        if (previousSelected) {
          if (previousSelected.id !== selectedStyle.id) {
            selected = true;
          }
        } else {
          selected = true;
        }
      }
      whileCount ++;
    }

    if (selectedStyle) {
      // const backgroundsImgs = catsImages.biu.replace(/https?:\/\//, 'http://') + '/';
      const backgroundsImgs = 'https://pbmp-remoteassets.pepblast.com/mov_bg/img-1920x1080/';
      const backImgLoc = selectedStyle.backImgLoc;
      const posterSrc = `${backgroundsImgs}${backImgLoc}`;
      const videoSrc = EXPRESS_URL.replace('{id}', selectedStyle.id);
      selectedStyle.posterSrc = posterSrc;
      selectedStyle.videoSrc = videoSrc;
    }
    
    return selectedStyle;
  },

  randomizeSong: async (style, songs) => {
    const filteredSongsIts = [];
    if (style && songs && songs.its && songs.its.length > 0) {
      songs.its.forEach((item) => {
        if (item.ci && item.ci.includes(style)) {
          filteredSongsIts.push(item);
        }
      });
    }

    let selectedSong;
    if (filteredSongsIts && filteredSongsIts.length > 0) {
      const maxRandom = (filteredSongsIts.length > 16) ? 15 : filteredSongsIts.length - 1;
      const random = randomIntFromInterval(0, maxRandom);
      selectedSong = (filteredSongsIts[random]);
    } else if (songs && songs.its && songs.its.length > 0) {
      // Select any other random song
      const maxRandom = (songs.its.length > 16) ? 15 : songs.its.length - 1;
      const random = randomIntFromInterval(0, maxRandom);
      selectedSong = (songs.its[random]);
    }
    
    return selectedSong;
  },

  randomizeMediaPack: (style, genresMap, map) => {
    let result = null;
    if (style && map) {
      if (map[style]) {
        result = map[style].mediapack;
      }
    } else if (style && genresMap && genresMap.length > 0) {
      const filteredItem = genresMap.filter((value) => {
        return parseInt(value.catid) === parseInt(style);
      });
      // Style is in genres map
      if (filteredItem.length > 0) {
        result = parseInt(style);
      }
    }

    if ((result === null) && genresMap && genresMap.length > 0) {
      // Generating a random style for media pack
      const maxRandom = genresMap.length - 1;
      const random = randomIntFromInterval(0, maxRandom);
      const selectedStyle = genresMap[random];
      if (selectedStyle && selectedStyle.catid) {
        result = parseInt(selectedStyle.catid);
      }
    }

    return result;
  },

  generateTextPhoto: async (text, photo, photoWidth = null, photoHeight = null) => {
    const canvas = document.createElement('canvas');
    canvas.width = TextPhotoDefaults.CANVAS_DEFAULT_WIDTH;
    canvas.height = TextPhotoDefaults.CANVAS_DEFAULT_HEIGHT;

    const layers = [];
    layers[0] = { id: LayerIdGenerator.generate(), type: 'image', file: null, dataUri: photo };
    layers[1] = { id: LayerIdGenerator.generate(), type: 'shadow', color: TextPhotoDefaults.CANVAS_DEFAULT_BACKGROUND_COLOR };
    if (text.length > 0) {
      text.forEach((item, index) => {
        layers[index + 2] = {
          id: LayerIdGenerator.generate(), 
          type: 'text', 
          content: item, 
          x: canvas.width/2,
          color: TextPhotoDefaults.CANVAS_DEFAULT_TEXT_COLOR,
          fontSize: TextPhotoDefaults.CANVAS_DEFAULT_FONT_SIZE,
          font: TextPhotoDefaults.CANVAS_DEFAULT_FONT,
          textAlign: TextPhotoDefaults.CANVAS_DEFAULT_TEXT_ALIGN
        };
      });
    }

    try {
      let lineHeightSum = (text.length > 3) ? (-1 * ((text.length - 3) * TextPhotoDefaults.CANVAS_DEFAULT_LINE_HEIGHT)) :  0;
      for (const item of layers) {
        if (item && item !== null) {
          if (item.type) {
            if (item.type === 'image') {
              await CanvasHelper.addImage({ canvas: canvas, imageDataURI: item.dataUri })
            } else if (item.type === 'shadow') {
              CanvasHelper.addBackgroundColor({ canvas: canvas, color: item.color });
            } else if (item.type === 'text') {
              item.y = canvas.height/2 + lineHeightSum;

              const renderedSizes = CanvasHelper.addText({
                canvas: canvas,
                text: item.content,
                color: item.color,
                x: item.x,
                y: item.y,
                fontSize: item.fontSize,
                font: item.font,
                textAlign: item.textAlign
              });

              if (renderedSizes && renderedSizes.w) {
                item.renderedW = renderedSizes.w;
              }
              if (renderedSizes && renderedSizes.h) {
                item.renderedH = renderedSizes.h;
                lineHeightSum += renderedSizes.h;
              }

              if (photoWidth) {
                item.w = photoWidth;
              }
              if (photoHeight) {
                item.h = photoHeight;
              }
            }
          }
        }
      }
  
      const base64Final = canvas.toDataURL('image/jpeg', 0.8);
  
      return {layers, renderedImage: base64Final};
    } catch (err) {
      return false;
    }
  },

  generateBasePhotoWithLayer: async (layers) => {
    const canvas = document.createElement('canvas');
    canvas.width = TextPhotoDefaults.CANVAS_DEFAULT_WIDTH;
    canvas.height = TextPhotoDefaults.CANVAS_DEFAULT_HEIGHT;

    if (layers.length < 2) {
      return false;
    }

    try {
      for (const item of layers) {
        if (item && item !== null) {
          if (item.type) {
            if (item.type === 'image') {
              await CanvasHelper.addImage({ canvas: canvas, imageDataURI: item.dataUri })
            } else if (item.type === 'shadow') {
              CanvasHelper.addBackgroundColor({ canvas: canvas, color: item.color });
            }
          }
        }
      }
  
      const base64Final = canvas.toDataURL('image/jpeg', 0.8);
  
      return base64Final;
    } catch (err) {
      return false;
    }
  },

  intercalateArrays: (photos, textPhotos) => {
    let elements = [];
    const photosLength = photos.length;
    const textPhotosLength = textPhotos.length;

    if (photosLength > 0 && textPhotosLength > 0) {
      const totalLength = photosLength + textPhotosLength;

      let indexPhoto = 0;
      let indexText = 0;

      if (textPhotosLength === 1) {
        for (let i=0;i<totalLength;i++) {
          if (i === 1) {
            elements.push(textPhotos[indexText]);
            indexText ++;
          } else {
            elements.push(photos[indexPhoto]);
            indexPhoto ++;
          }
        }
      } else if (textPhotosLength === 2) {
        for (let i=0;i<totalLength;i++) {
          if (i === 1 || i === totalLength - 3) {
            elements.push(textPhotos[indexText]);
            indexText ++;
          } else {
            elements.push(photos[indexPhoto]);
            indexPhoto ++;
          }
        }
      } else {
        const middleElementsLength = totalLength - 5;
        const interval = parseInt((photosLength - 3) / (textPhotosLength - 2)) - 1;

        let middleElements = [];
        let middlePhotosElements = [];
        let middleTextPhotoElements = [];
        for (let i=1;i<photosLength - 2;i++) {
          middlePhotosElements.push(photos[i]);
        }
        for (let i=1;i<textPhotosLength - 1;i++) {
          middleTextPhotoElements.push(textPhotos[i]);
        }

        let intervalCounter = 0;
        for (let i=0;i<middleElementsLength;i++) {
          if (intervalCounter < interval) {
            middleElements.push(middlePhotosElements[indexPhoto]);
            intervalCounter ++;
            indexPhoto ++;
          } else {
            middleElements.push(middleTextPhotoElements[indexText]);
            indexText ++;
            intervalCounter = 0;
          }
        }

        elements = [
          photos[0],
          textPhotos[0],
          ...middleElements,
          textPhotos[textPhotosLength - 1],
          photos[photosLength - 2],
          photos[photosLength - 1]
        ];
      }
    }
    return elements;
  },

  generateTextLayerBreakLine: (item) => {
    const canvas = document.createElement('canvas');
    canvas.width = TextPhotoDefaults.CANVAS_DEFAULT_WIDTH;
    canvas.height = TextPhotoDefaults.CANVAS_DEFAULT_HEIGHT;

    let rendered = CanvasHelper.addTextWrap({
      canvas: canvas,
      text: item.content,
      color: item.color,
      font: item.font, 
      fontSize: item.fontSize,
      textAlign: item.textAlign,
    });

    return rendered;
  },

  openRemixTinyPage: (tid) => { window.open(`${PUBLIC_VIDEOS_URL}+${tid}`); },

  openPopFansTinyPage: (tid) => { window.open(`${PUBLIC_VIDEOS_URL_POPFANS}+${tid}`); },

  openRemixPage: (rid) => { window.open(`${REMIX_APP_WEB}?r=${rid}`); },

  openPopFansPage: (rid) => { window.open(`${POPFANS_APP_WEB}?r=${rid}`) },

  generateSocialLinksDescription: (rde='', links, skin, hashtags) => {
    let description = rde;
    if (links && links.length > 0) {
      description = `${description} \n\n`;
      links.forEach((item) => { description = `${description}${item.label}: ${item.link}\n` });
    }
    if (skin) {
      description = `${description}\n\n ((+))${skin}`;
    }
    if (hashtags && hashtags.length > 0) {
      description = `${description} \n\n ||)`;
      hashtags.forEach((item) => { description = `${description} #${item}` });
    }
    return description;
  },

  processHashtagStyle: ((hashTagToSet) => {
    if (hashTagToSet) {
      hashTagToSet = hashTagToSet.toLowerCase();
      hashTagToSet = hashTagToSet.trim();
      hashTagToSet = hashTagToSet.replaceAll(' ', '');
      hashTagToSet = hashTagToSet.replace(/[^a-z0-9 _]/g, ''); // Remove all special chars except space and underline
      return hashTagToSet;
    } else {
      return '';
    }
  }),

}

export default RemixHelper;
